<section>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <div class="mt-20 text-center">
                    <h5 class="font-size-14 mb-1">Sign in with</h5>
                    <ul class="list-inline">
                        <li class="list-inline-item" (click)="googleSignIn()"><a class="sociallogo"><img
                                    src="../../assets/images/google-logo.svg" class="button-logo"> Sign in with
                                Google </a></li>
                        <li class="list-inline-item"><a class="sociallogo" (click)="MSLogin()"><img
                                    src="../../assets/images/microsoft.svg" class="button-logo"> Sign in with
                                Microsoft </a></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-4 offset-md-4" *ngIf="invalid">
                <p>
                    <ngb-alert [dismissible]="false" class="text-center">
                        Invalid Credentials
                    </ngb-alert>
                </p>
            </div>
        </div>
    </div>
</section>